import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'tms-lib';
import { MagentoStockItems, StockItemMagento } from '../../models';
import { TmsWebBaseService } from '../base/tms-web-base.service';

@Injectable({
  providedIn: 'root',
})
export class StockItemsMagentoService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('StockItemMagento', httpService);
  }

  getStockItems(qty: number): Observable<MagentoStockItems> {
    return this.httpService.get<MagentoStockItems>(`${this.apiUrl}/GetStockItem/${qty}`);
  }

  importStockItems(): Observable<StockItemMagento[]> {
    return this.httpService.post<StockItemMagento[]>(`${this.apiUrl}/ImportStockItems`, {});
  }

  importSaleableQuantity(sellingCompany: string): Observable<StockItemMagento[]> {
    return this.httpService.post<StockItemMagento[]>(`${this.apiUrl}/ImportSaleableQuantity`, { sellingCompany });
  }
}
